import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2d1fd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    draggable: true,
    style: _normalizeStyle(_ctx.style),
    class: "drag-item",
    ref: "divRef",
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mousedown && _ctx.mousedown(...args)), ["prevent"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handles, (handle, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass([_ctx.classNameHandle, _ctx.classNameHandle + '-' + handle]),
        onMousedown: _withModifiers(($event: any) => (_ctx.handleDown(handle, $event)), ["stop","prevent"])
      }, [
        _renderSlot(_ctx.$slots, handle, {}, undefined, true)
      ], 42, _hoisted_1)), [
        [_vShow, _ctx.active]
      ])
    }), 128)),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 36))
}